import React, { Component } from 'react'
import { connect } from 'react-redux'
import NotificationSystem from 'react-notification-system'

const style = {
  Containers: {
    DefaultStyle: {
      marginTop: '5em',
      marginRight: '2em',
    },
  },
  NotificationItem: {
    DefaultStyle: {
      fontSize: '20px',
      padding: '20px',
      height: 'auto',
    },
  },
}

class Notifications extends Component {
  componentDidMount () {
    this.notificationSystem = this.refs.notificationSystem
  }

  componentWillReceiveProps (nextProps) {
    const { message, level } = nextProps
    if (!message) return
    this.notificationSystem.addNotification({
      autoDismiss: 10,
      message,
      level,
    })
  }

  render () {
    return (
      <NotificationSystem
        key='notificationSystem'
        className='notification-system'
        style={style}
        ref='notificationSystem'
      />
    )
  }
}

const mapStateToProps = state => ({
  message: state.notification.message,
  timestamp: state.notification.timestamp,
  level: state.notification.level,
})

export default connect(mapStateToProps)(Notifications)



// WEBPACK FOOTER //
// ./src/components/UI/Notifications/Notifications.jsx